<template lang="pug">
  .searching.container.mx-auto(v-if="(products && products.loading) || loading")
    Spinner(:size="10" :thickness="2")
  .found.container.mx-auto(v-else-if="query" ref="container")
    template(v-if="products && products.items && products.items.length")
      .alert
        p Hier die Produkte zu Ihrer Suche nach "<b>{{ query }}</b>"
      .teasers(v-if="teasers && teasers.length" ref="teasers")
        .top-row.flex(v-if="(teasers && teasers.length) || showFilters")
          .filters.flex-grow
        .justified.paginated-teasers(v-if="activeOrientation === 'justified'" :style="{ height: `${layoutGeometry.containerHeight}px` }")
          Teaser(
            v-for="teaser in cards"
            :key="teaser.id"
            v-if="teaser"
            :teaser="teaser"
            display="card"
          )
        .horizontal.paginated-teasers(v-else-if="activeOrientation === 'horizontal'")
          Teaser(
            v-for="teaser in teasers"
            :key="teaser.id"
            v-if="teaser"
            :teaser="teaser"
            display="card"
          )
        .vertical.paginated-teasers(v-else-if="activeOrientation === 'vertical'")
          Teaser(
            v-for="teaser in teasers"
            :key="teaser.id"
            v-if="teaser"
            :teaser="teaser"
            display="row"
          )
      Pagination(
        v-if="pageInfo && pageInfo.lastPage > 1"
        :last-page="pageInfo.lastPage"
        :current-page="pageInfo.currentPage"
        nav-class="pagination is-rounded is-centered"
        @change="changePage"
      )
        template(v-slot:prev)
          span.icon
            i.fas.fa-arrow-left
        template(v-slot:next)
          span.icon
            i.fas.fa-arrow-right
    .alert.warning(v-else)
      p Zu der Suche nach "<b>{{ query }}</b>" konnten keine Produkte gefunden werden
</template>

<script>
import CategoryProducts from '@/extensions/shop/components/CategoryProducts';

import { get, cloneDeep } from '@/helpers';

export default {
    name: 'ProductSearchResults',
    extends: CategoryProducts,
    data: () => ({
        // ...
    }),
    watch: {
        '$route.query'(query) {
            window.scrollTo(0, 0);
            this.currentPage = get(query, `P${this.section.id}`) || 1;
            this.refetch(this.query);
        }
    },
    computed: {
        query() {
            return get(this.$route, 'query.s');
        }
    },
    methods: {
        refetch(query) {
            if (!query) return false;
            this.loading = true;

            const shop = get(this.cms, 'shop.id');
            const payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: 15
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'query',
                        like: this.query
                    },
                    {
                        key: 'qty_sum',
                        from: 1
                    }
                ],
                order: 'nr',
                direction: 'asc'
            };

            this.fetchProducts(payload).then(response => {
                if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
                    this.changePage(response.pageInfo.lastPage);
                    return;
                }

                const products = cloneDeep(response);
                const container = document.querySelector('.preorder-columns > .column.left > .ps');
                if (container) container.scrollTop = 0;

                if (products.items && products.items.length) {
                    products.items.forEach((product, i) => {
                        product.position = i + 1;
                    });
                }

                this.products = products;
                // this.insertProducts({ products });
                this.loading = false;
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.query) {
                this.refetch(this.query);
            } else {
                this.products.loading = false;
            }
        });
        document.body.classList.add('background-product-page');
    },
    destroyed() {
        document.body.classList.remove('background-product-page');
    }
};
</script>

<style lang="sass" scoped>
.searching
  min-height: 4rem

.alert
  margin-bottom: 2rem

.products ::v-deep .arrow-container
  display: none

.found
  display: flex
  flex-direction: column
  flex-grow: 1
  .teasers
    width: 100%
  .pagination-container
    margin-top: 1rem
    max-width: 100%
  .paginated-teasers
    &.horizontal
      // align-content: space-around
      // justify-content: space-between
      @screen sm
        @apply grid
        gap: 1rem
        grid-template-columns: 1fr
        grid-template-columns: repeat(2, minmax(0, 1fr))
        ::v-deep
          figure
            width: 100%
            height: 292px
      @screen md
        grid-template-columns: repeat(2, minmax(0, 1fr))
        ::v-deep
          figure
            width: 100%
            height: 360px
      @screen lg
        grid-template-columns: repeat(3, minmax(0, 1fr))
        ::v-deep
          figure
            width: 100%
            height: 330px
      @screen xl
        grid-template-columns: repeat(3, minmax(0, 1fr))
        ::v-deep
          figure
            width: 100%
            height: 330px
      @screen 2xl
        grid-template-columns: repeat(4, minmax(0, 1fr))
        ::v-deep
          figure
            width: 283px
            height: 283px
      // @screen md
      //   @apply flex flex-wrap
      //   // justify-between
      //   ::v-deep .product-teaser
      //     width: 300px
      .product-teaser-link
        display: block
        & + .product-teaser-link
          margin-top: 1rem
          @screen sm
            margin-top: 0

    &.vertical
      // TODO
    &.justified
      position: relative
</style>
